import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const usePurgeProject = (projectId, version) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();
  return useMutation(
    async (origins) => {
      await fetchContext.authAxios.post(
        `/projects/${projectId}/versions/${version}/purge`,
        { origins, version }
      );
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries([
          "project",
          projectId.toString(),
          "info",
        ]);
      },
    }
  );
};
